const getNavHeight = () => {
  const width = window.innerWidth
  if (width < 600) return 44
  return 68
}

export const scrollToRef = (ref: React.RefObject<HTMLDivElement | null>) => {
  const navHeight = getNavHeight()
  const top = ref.current?.getBoundingClientRect()
    ? ref.current.getBoundingClientRect().top + window.scrollY - navHeight
    : null
  if (top) window.scrollTo({ top, behavior: 'smooth' })
}
